
<div >
  <div class="row">
    <div class="col-12 col-lg-6">
      <div class="row nsc-row--12">
        @if (editRecipient.observers.length) {
          <div class="col-auto">
            <button attr.aria-label="Edit Recipient: {{content.recipient}}" class="nsc-mat-button" mat-button (click)="edit()"><mat-icon aria-hidden="true">edit</mat-icon> Edit</button>
          </div>
        }
        @if (deleteRecipient.observers.length) {
          <div class="col-auto">
            <button attr.aria-label="Remove Recipient: {{content.recipient}}" class="nsc-mat-button" mat-button (click)="delete()"> <mat-icon aria-hidden="true">delete</mat-icon> Remove</button>
          </div>
        }
      </div>
    </div>
    @if (recipient.fees.totalFee !== 0 || ((isTNSchool || isSPDESchool || isFASTSchool) && recipient.fees.totalFee === 0)) {
      <div class="col-12 col-lg-6">
        <div class="row nsc-recipient-details__total-fee nsc-recipient-details__content">
          <div class="col-6">
            <!-- <strong>{{ recipient.fees.totalFee.description }}:</strong> -->
            <strong>Total Fee for this Recipient:</strong>
          </div>
          <div class="col-6">
            {{ recipient.fees.totalFee | currency }}
            @if (((isTNSchool && recipient.fees.totalFee === 0)|| isSPDESchool || isFASTSchool)) {
              <button (click)="viewTotalFeeDetails()" mat-icon-button aria-label="info">
                <mat-icon>info</mat-icon>
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <nsc-spacer></nsc-spacer>

  <div class="row nsc-recipient-details__content">
    <div class="col-12 col-lg-6">
      <div>
        <strong>Recipient: </strong>{{ this.content.recipient }}
      </div>
      @if (isOther()) {
        <div>
          @if (recipient.address.attention) {
            <span style="display: block;">
              <strong>Attention: </strong>{{ recipient.address.attention }}
            </span>
          }
          <strong>Recipient Address:</strong>
          <div class="nsc-recipient-details__address">
            {{ recipient.address.addressLine1 }}<br>
            {{ recipient.address.addressLine2 }}@if (recipient.address.addressLine2) {
            <br>
            }
            {{ recipient.address.city }},@if (recipient.address.state !='ZZ') {
            <span> {{ recipient.address.state }} </span>
            } @if (recipient.address.zip !='N/A') {
            <span>{{ recipient.address.zip }} </span>
          }
          @if (recipient.address.country !== 'US') {
            <div>{{ getFullCountryName(recipient.address.country) | uppercase}}</div>
          }
        </div>
      </div>
    }

    @if (isElectronicPDF()) {
      <div>
        <strong>Email: </strong>{{ recipient.address.emailPrimary || recipient.who.emailPrimary }}
      </div>
    }

    @if (isETX() && !isCentralInbox() && !isAttentionNotVisible()) {
      <div>
        <strong>Attention: </strong>{{ content.etxDepartmentName || recipient.address.attention }}
      </div>
    }

    @if (isCentralInbox() && !isAttentionNotVisible()) {
      <div>
        <strong>Attention: </strong>{{ recipient.address.emailPrimary || recipient.who.emailPrimary }}
      </div>
    }

  </div>
  <div class="col-12 col-lg-6" >
    <div class="d-lg-none">
      <nsc-spacer></nsc-spacer>
    </div>

    @if (content.processingOption) {
      <div class="row">
        <div class="col-6">
          <strong>Processing Option:</strong>
        </div>
        <div class="col-6">
          {{ content.processingOption.description }}
        </div>
      </div>
    }

    @if (recipient.fees.transcriptTypeFee !== 0) {
      <div class="row">
        <div class="col-6">
          <strong>Transcript Type:</strong>
        </div>
        <div class="col-6">
          {{ content.transcriptType.display }}
        </div>
      </div>
    }

    @if (content.deliveryMethod) {
      <div class="row nsc-recipient-details__delivery-method">
        <div class="col-6 nsc-recipient-details__delivery-method--name">
          <strong>Delivery Method:</strong>
        </div>
        <div class="col-6 ">
          <div class="nsc-recipient-details__delivery-method--content">
            <span>{{ content.deliveryMethodDisplay }}</span>
            <button (click)="viewDetails()" mat-icon-button aria-label="info">
              <mat-icon>info</mat-icon>
            </button>
          </div>
        </div>
      </div>
    }

    @if (content.quantity) {
      <div class="row">
        <div class="col-6">
          <strong>Quantity:</strong>
        </div>
        <div class="col-6">
          {{ content.quantity.displayWithFee.split('=')[0].toString() }}
        </div>
      </div>
}

      @if (recipient.fees.transcriptFee !== 0) {
<div class="row">
        <div class="col-6">
          
              <strong>Transcript Quantity Fee:</strong>
        </div>
        <div class="col-6">
          {{ recipient.fees.transcriptFee| currency }}
        </div>
      </div>
}

      @if (recipient.fees.deliveryFee !== 0) {
<div class="row">
        <div class="col-6">
          <strong>{{ recipient.fees.deliveryFeeDescription}}:</strong>

        </div>
        <div class="col-6">
            {{ recipient.fees.deliveryFee | currency }}
        </div>
      </div>
}

      @if (recipient.fees.transcriptTypeFee !== 0 ) {
<div class="row">
        <div class="col-6">
              <strong>Transcript Type Fee:</strong>
        </div>
        <div class="col-6">
          {{ recipient.fees.transcriptTypeFee | currency }}
        </div>
      </div>
}

      @if (recipient.fees.shippingAndHandlingFee !== 0) {
<div class="row">
        <div class="col-6">
           <strong>Shipping and Handling Fee:</strong>
        </div>
        <div class="col-6">
          {{ recipient.fees.shippingAndHandlingFee | currency }}
        </div>
      </div>
}

      @if (recipient.fees.onlineProcessingFee !== 0) {
<div class="row">
        <div class="col-6">
              <strong>Online Processing Fee:</strong>
        </div>
        <div class="col-6">
          {{ recipient.fees.onlineProcessingFee | currency }}
        </div>
      </div>
}

      @if (isAttachmentAvailable()) {
<div class="row">
          <div class="col-6">
              <strong>Documents Uploaded:</strong>
          </div>
          <div class="col-6"></div>
       </div>
}
       @if (isAttachmentAvailable()) {
<div>
          @for (attachment of content.attachments; track attachment; let i = $index) {
<div class="row">
              @if (attachment.originalFileName) {
<div class="col-12">
                  {{ attachment.originalFileName }}
              </div>
}
              @if (attachment.attachmentResponse) {
<div class="col-12">
                  {{ attachment.attachmentResponse.originalFileName }}  
              </div>
}
          </div>
}
          
      </div>
}
    </div>
  </div>
</div>
